import { useBreakpoint } from '@/hooks/useBreakpoint';
import MillerColumnBrowser from './miller/MillerColumnBrowser';
import MobileKnowledgeBrowser from './miller/MobileKnowledgeBrowser';

interface KnowledgeTabProps {
  projectId: string;
  onSwitchToMarkupReview?: (knowledgeItemId?: string, revisionId?: string) => void;
}

export default function KnowledgeTab({ projectId, onSwitchToMarkupReview }: KnowledgeTabProps) {
  const { isDesktop } = useBreakpoint();

  return (
    <div style={{ height: 'calc(100vh - 64px - 120px)' }}>
      {isDesktop ? (
        <MillerColumnBrowser
          projectId={projectId}
          onOpenViewer={(knowledgeItemId, revisionId) =>
            onSwitchToMarkupReview?.(knowledgeItemId, revisionId)
          }
        />
      ) : (
        <MobileKnowledgeBrowser
          projectId={projectId}
          onOpenViewer={(knowledgeItemId, revisionId) =>
            onSwitchToMarkupReview?.(knowledgeItemId, revisionId)
          }
        />
      )}
    </div>
  );
}
